import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AzzurroTable, SimpleButtonComponent, SimpleInputComponent, TitleContentComponent } from 'ngx-zcs-components';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { IonicModule } from '@ionic/angular';
import { MatChipsModule } from '@angular/material/chips';
import { MatPaginatorModule } from '@angular/material/paginator';

import { EventRegistryComponent } from './event-registry.component';
import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { EventRegistryService } from './event-registry.service';

@NgModule({
  imports: [
    AzzurroTable,
    BlockTitleComponent,
    CommonModule,
    FormsModule,
    IonicModule,
    MatCheckboxModule,
    MatChipsModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatPaginatorModule,
    MatSelectModule,
    ReactiveFormsModule,
    SimpleButtonComponent,
    SimpleInputComponent,
    TitleContentComponent,
  ],
  declarations: [EventRegistryComponent],
  exports: [EventRegistryComponent],
  providers: [
    EventRegistryService,
  ],
})
export class EventRegistryComponentModule {}
